import { applyMiddleware, createStore } from 'redux';
import { combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk'; // Use the named export
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import createIdbStorage from '@piotr-cz/redux-persist-idb-storage';
import { userDataReducer } from './reducers/auth';
import { userInfoReducer } from './reducers/userInfoReducer';

const composeEnhancers =
    typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : (f) => f;

// Combine reducers
const rootReducer = combineReducers({
    loginData: userDataReducer,
    userDetails: userInfoReducer,
});

// Configure persistence
const persistConfig = {
    key: 'mainPersistReducer',
    version: 1,
    storage: createIdbStorage({ name: 'mainApp' }),
    whitelist: ['loginData', 'userDetails'],
};

const syncMiddleware = createStateSyncMiddleware({
    whitelist: ['loginData', 'userDetails'],
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Apply middleware
const middlewares = [thunk, syncMiddleware];
const storeEnhancers = composeEnhancers(applyMiddleware(...middlewares));

const mainStore = createStore(persistedReducer, storeEnhancers);
initMessageListener(mainStore);

const mainPersistor = persistStore(mainStore);

export { mainStore, mainPersistor };
